import _ from 'lodash';

const isTestEnvironment = () => {
  return process.env.NODE_ENV === 'test';
};

let mixpanel = null;
let isInitialized = false;

if (!isTestEnvironment()) {
  try {
    const mixpanelBrowser = require('mixpanel-browser');
    mixpanel = mixpanelBrowser.default || mixpanelBrowser;
  } catch (e) {
    // Silently fail in non-browser environments
  }
}

const isMixpanelEnabled = () => {
  if (isTestEnvironment()) {
    return false;
  }

  const env = process.env.REACT_APP_ENVIRONMENT;
  const isLocal = process.env.REACT_APP_IS_LOCAL === 'true';

  return _.includes(['production', 'staging'], env) || isLocal;
};

const initializeMixpanel = () => {
  if (!isMixpanelEnabled()) {
    return false;
  }

  if (!mixpanel) {
    return false;
  }

  const token = process.env.REACT_APP_MIXPANEL_TOKEN;
  if (!token) {
    return false;
  }

  try {
    mixpanel.init(token, {
      debug: false,
      track_pageview: false,
      persistence: 'localStorage',
      ignore_dnt: false,
      autocapture: false,
    });
    return true;
  } catch (error) {
    console.error('Mixpanel: Initialization failed', error);
    return false;
  }
};

isInitialized = initializeMixpanel();

export const identifyUser = (userId, userProperties = {}) => {
  if (!isInitialized || !mixpanel) return;

  try {
    mixpanel.identify(userId);
    if (!_.isEmpty(userProperties)) {
      mixpanel.people.set(userProperties);
    }
  } catch (error) {
    console.error('Mixpanel: Error identifying user', error);
  }
};

export const trackMixpanelEvent = (eventName, properties = {}) => {
  if (!isInitialized || !mixpanel) return;

  try {
    mixpanel.track(eventName, properties);
  } catch (error) {
    console.error('Mixpanel: Error tracking event', error);
  }
};

export const setUserProperties = (properties = {}) => {
  if (!isInitialized || !mixpanel) return;

  try {
    mixpanel.people.set(properties);
  } catch (error) {
    console.error('Mixpanel: Error setting user properties', error);
  }
};

export const resetMixpanel = () => {
  if (!isInitialized || !mixpanel) return;

  try {
    mixpanel.reset();
  } catch (error) {
    console.error('Mixpanel: Error resetting', error);
  }
};

export default {
  identify: identifyUser,
  track: trackMixpanelEvent,
  setUserProperties,
  reset: resetMixpanel,
};
